import Title from '../title/Title'
import FriendSlider from './FriendSlider'

import './friends.css'

const Friends = ({friends}) => {

      if(friends.data) return 

      return (
            <div className="friends_page">
                  <Title text={`Friends`}/>
                  <div className="friend_slider">
                        <FriendSlider friends={friends} />
                  </div>
            </div>
      )
}

export default Friends
